import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=5f2d8dd4&"
import script from "./Truck.vue?vue&type=script&lang=ts&"
export * from "./Truck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports